import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { HttpClient, HttpHandler, HttpXhrBackend } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';


import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { metaReducersDev, metaReducersProd } from '@gp-angular/shared/ngrx';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '@gp-angular/shared/module';
import { SharedComponentModule } from '@gp-angular/shared/component';
import { ApplicationDateAdapterService, ApplicationService, ServiceApplicationModule } from '@gp-angular/service/application';
import { AnalyticsService, ServiceAnalyticsModule } from '@gp-angular/service/analytics';
import { AppointmentService, ServiceAppointmentModule } from '@gp-angular/service/appointment';
import { ContentManagementService, ServiceContentManagementModule } from '@gp-angular/service/content-management';
import { DialogService, ServiceDialogModule } from '@gp-angular/service/dialog';
import { HttpAuthInterceptor, HttpEndpointsModule, httpServiceFactory, RequestOptions } from '@gp-angular/service/http';
import { MessageService, ServiceMessageModule } from '@gp-angular/service/message';
import { MediaService, ServiceMediaModule } from '@gp-angular/service/media';
import { ProviderService, ServiceProviderModule } from '@gp-angular/service/provider';
import { ServiceUserModule, UserService } from '@gp-angular/service/user';
import { HttpLoaderFactory, InitTranslateFactory } from '@gp-angular/service/translate';


const metaReducers: Array<MetaReducer<any, any>> = environment.production ? metaReducersProd : metaReducersDev;

const devModule: Array<any> = environment.production ? [] : [StoreDevtoolsModule.instrument({
	maxAge: 25, // Retains last 25 states
})];

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		TranslateModule.forRoot({
			defaultLanguage: 'de',
			loader: {
				provide: TranslateLoader,
				useFactory: (HttpLoaderFactory),
				deps: [HttpClient]
			},
			isolate: false,
			extend: true
		}),
		StoreModule.forRoot({}, {
			metaReducers,
			runtimeChecks: {
				strictStateImmutability: true,
				strictActionImmutability: true,
				strictStateSerializability: false,
				strictActionSerializability: false,
				strictActionWithinNgZone: true,
				strictActionTypeUniqueness: true
			}
		}),
		EffectsModule.forRoot([]),
		...devModule,

		BrowserModule,

		AppRoutingModule,

		BrowserModule,
		BrowserAnimationsModule,

		HttpEndpointsModule, // Root!!!

		SharedModule,
		SharedComponentModule,

		ServiceAnalyticsModule,
		ServiceApplicationModule,
		ServiceAppointmentModule,
		ServiceContentManagementModule,
		ServiceDialogModule,
		ServiceMediaModule,
		ServiceMessageModule,
		ServiceProviderModule,
		ServiceUserModule,
	],
	exports: [
		TranslateModule
	],
	providers: [
		{provide: 'ENVIRONMENT', useValue: environment},
		{provide: DateAdapter, useClass: ApplicationDateAdapterService},
		{
			provide: APP_INITIALIZER,
			useFactory: InitTranslateFactory,
			deps: [TranslateService, Injector],
			multi: true
		},
		{
			provide: HttpClient,
			useFactory: httpServiceFactory,
			deps: [HttpXhrBackend, HttpAuthInterceptor, RequestOptions, HttpHandler]
		},

		AnalyticsService,
		ApplicationService,
		AppointmentService,
		ContentManagementService,
		DialogService,
		MediaService,
		MessageService,
		ProviderService,
		UserService,
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
